import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Container from '../Container';

const StyledContainer = styled(Container)`
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

const CarouselItem = ({ children, ...props }) => (
  <StyledContainer {...props} flex="0 0 100%">
    {children}
  </StyledContainer>
);

CarouselItem.propTypes = {
  children: PropTypes.node,
};

CarouselItem.defaultProps = {
  children: null,
};

export default CarouselItem;
